<div class="pageheader">
  <div class="page-title">
    <h1>Compare rules import</h1>
  </div>
</div>

<app-import importMode="comparePlugin"></app-import>
